import { useQuery } from '@tanstack/react-query';
import type { AircraftDto, AircraftTypeDto } from '@wingseat/shared';
import { api } from '../lib/api-client';

export function useAircraftTypes() {
  return useQuery({
    queryKey: ['aircraft-types'],
    queryFn: () => api.get<AircraftTypeDto[]>('/aircraft-types'),
    staleTime: 5 * 60_000,
  });
}

export function useAircraft() {
  return useQuery({
    queryKey: ['aircraft'],
    queryFn: () => api.get<AircraftDto[]>('/aircraft'),
    staleTime: 5 * 60_000,
  });
}
